import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "../Box/Box.mjs";
import { useLinkComponent } from "../BraidProvider/BraidProvider.mjs";
import { useButtonStyles, ButtonContainer, ButtonOverlays, ButtonText } from "../Button/Button.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const ButtonLink = forwardRef(
  ({
    children,
    size,
    tone,
    variant,
    bleed,
    icon,
    iconPosition,
    loading,
    data,
    ...restProps
  }, ref) => {
    const LinkComponent = useLinkComponent(ref);
    const { root, content } = useButtonStyles({
      variant,
      tone,
      size,
      bleed,
      loading
    });
    return /* @__PURE__ */ jsx(ButtonContainer, { bleed, variant, children: /* @__PURE__ */ jsx(
      Box,
      {
        component: LinkComponent,
        outline: "focus",
        ref,
        ...restProps,
        ...root,
        ...buildDataAttributes({ data, validateRestProps: false }),
        children: /* @__PURE__ */ jsxs(Box, { ...content, children: [
          /* @__PURE__ */ jsx(ButtonOverlays, { variant, tone }),
          /* @__PURE__ */ jsx(
            ButtonText,
            {
              variant,
              tone,
              size,
              loading,
              icon,
              iconPosition,
              bleed,
              children
            }
          )
        ] })
      }
    ) });
  }
);
ButtonLink.displayName = "ButtonLink";
export {
  ButtonLink
};
